var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolygonPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.32971 3.79835C-0.209219 1.55272 1.88492 -0.434217 4.09917 0.221875L10.7419 2.19015C12.9561 2.84624 13.6298 5.65329 11.9545 7.24284L6.92855 12.0115C5.25323 13.601 2.48543 12.7809 1.9465 10.5353L0.32971 3.79835Z",
    fill: "#9AB1EC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonPurple);
export default __webpack_public_path__ + "static/media/polygon-purple.cdd3f93b86194ed137a489b85d93ba6f.svg";
export { ForwardRef as ReactComponent };